export default __webpack_public_path__ + "static/media/iOS.6a4f3046.png";